import React from 'react';

import './spinner.scss';

const Spinner: React.FC<{ isInline?: boolean; }> = ({ isInline }) => (
    <div className={`spinner${isInline ? ' spinner--inline' : ''}`}>
        {''}
    </div>
);

export default Spinner;
